import Backbone from 'backbone';

import template from './campaigns.pug';

export class CampaignsContextualAttributeView extends Backbone.View {
  initialize({
    newI18n,
    budgetAdjustmentOption,
  }) {
    this.newI18n = newI18n;
    this.budgetAdjustmentOption = budgetAdjustmentOption;
  }

  render({
    showDeliveryStatusPopup,
  }) {
    const {
      newI18n,
      budgetAdjustmentOption,
    } = this;

    this.$el.html(template({
      campaignsTitle: newI18n.getString(_TL_('Campaign names:')),
      campaigns: budgetAdjustmentOption.BudgetAdjustmentOptionConstrainedCampaigns,
    }));

    showDeliveryStatusPopup(this.el.outerHTML);
    return this;
  }
}
